import React, { Component } from 'react'
import { Redirect, withRouter } from 'react-router-dom'

class DocumentDetail extends Component {
  componentWillMount() {
    const { setHeader, match } = this.props
    setHeader({
      title: null,
      left: {
        text: 'back',
        url: "/document"
      },
      right: {
        text: 'edit',
        url: "/document/edit/" + match.params.id,
        admin: true
      }
    })
  }
  render() {
    const { documents, match } = this.props
    return (
      documents[match.params.id]?
        <div>
          <h1>{documents[match.params.id].title}</h1>
          <hr/>
          <div className="text" dangerouslySetInnerHTML={{__html: documents[match.params.id].text}}></div>
        </div>
      :
        <Redirect to="/document" />
    )
  }
}
export default withRouter(DocumentDetail)


// WEBPACK FOOTER //
// ./src/components/DocumentDetail.js